export default __webpack_public_path__ + "ae042b69f87cc0ea40599daad4a6d2c5.png";